// ---------------------------------------------------------------------------
// Pure derivations from the shared Doppler keys — one name per fact.
//
// The admin SPA reads the same keys the api does (`API_BASE_URL`, `NODE_ENV`)
// and derives what it needs from them, instead of carrying `VITE_*` copies of
// each value. Both readers call these:
// `vite.config.ts` (the dev-server proxy target, at config time) and
// `src/utils/env.ts` (the SPA, at runtime). No DOM or Vite types here, so the
// node tsconfig can compile it too.
// ---------------------------------------------------------------------------

/** Fallback api origin when `API_BASE_URL` is unset (local dev, unit tests). */
export const DEFAULT_API_ORIGIN = 'http://localhost:3000';

/** The api's route prefix; `API_BASE_URL` is the bare origin without it. */
export const API_PREFIX = '/v1';

function nonEmpty(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

/** The api origin from `API_BASE_URL`, trailing slashes trimmed. */
export function apiOriginFrom(apiBaseUrl: string | undefined): string {
  return (nonEmpty(apiBaseUrl) ?? DEFAULT_API_ORIGIN).replace(/\/+$/, '');
}

/** The SPA's axios base: `${API_BASE_URL}/v1`. */
export function apiBaseFrom(apiBaseUrl: string | undefined): string {
  return `${apiOriginFrom(apiBaseUrl)}${API_PREFIX}`;
}

/**
 * The environment label (`development` | `staging` | `production`) from
 * `NODE_ENV`, which Doppler keeps in lock-step with that set. Unset or blank →
 * undefined, so a caller can tell "not configured" from a real value.
 */
export function appEnvFrom(nodeEnv: string | undefined): string | undefined {
  return nonEmpty(nodeEnv);
}
